import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const HeroSection = ({ onRequestAccess }) => {
  const { t } = useLanguage();

  return (
    <section className="relative bg-gradient-to-br from-[#0025cc] to-[#0025cc] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6 md:mb-8">
            <Icon name="Shield" size={20} color="#FFFFFF" />
            <span className="text-sm md:text-base font-medium">{t('hero.badge')}</span>
          </div>
          
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 leading-tight">
            {t('hero.title')}<br />{t('hero.titleLine2')}
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-blue-100 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            {t('hero.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="default" 
              size="lg"
              onClick={onRequestAccess}
              className="bg-white text-[#0025cc] hover:bg-white/90 w-full sm:w-auto"
              iconName="ArrowRight"
              iconPosition="right"
            >
              {t('hero.requestAccess')}
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-white text-white hover:bg-white/10 w-full sm:w-auto"
            >
              {t('hero.learnMore')}
            </Button>
          </div>
          
          <div className="mt-12 md:mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-sm md:text-base">
            <div className="flex items-center gap-2">
              <Icon name="Shield" size={20} color="#FFFFFF" />
              <span>{t('hero.feature1')}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Users" size={20} color="#FFFFFF" />
              <span>{t('hero.feature2')}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Building2" size={20} color="#FFFFFF" />
              <span>{t('hero.feature3')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;